/* @flow */
import GroupStore from 'groups/stores/GroupStore';
import Group from 'entities/Group';

/**
 * @deprecated use the group's postable roles instead
 */
export function getDefaultGroups(groupCode: string): Group[] {
  const postableGroups = GroupStore.getPostableGroups().models;

  // If there is only one postable class, always use it
  if (postableGroups.length === 1) {
    return postableGroups;
  } else if (groupCode) {
    const group: Group = GroupStore.getGroupForCode(groupCode);
    if (postableGroups.includes(group)) {
      return [group];
    }
    return [];
  } else {
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/lib/getDefaultGroups.js